// src/App.js
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { UserProvider } from './contexts/UserContext';
import MainApp from './MainApp';
import 'leaflet/dist/leaflet.css';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <UserProvider>
                    <MainApp />
                </UserProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
